import { archiveButtonDataTip } from '../../../../Utilities/HelperFunction/archiveButtonDataTip';
import useAxiosInstance from '../../../../Utilities/Hooks/useAxiosInstance';
import './ArchiveItem.css'

function ArchiveItem({ api, targetID, setShowDeleteSection, setShowModal, triggerFetch, isActive, isArchive }) {
  const axiosInstance = useAxiosInstance();

  const buttonText = archiveButtonDataTip(isActive, isArchive)

  async function handleArchive(id) {

    let data;

    if (isActive !== undefined) {
      const updatedIsActive = !isActive;
      data = { isActive: updatedIsActive };
    } else {
      const updatedIsArchive = !isArchive;
      data = { isArchive: updatedIsArchive };
    }

    const res = await axiosInstance.patch(`${api}${id}`, data);

    if (res.data) {
      setShowModal(false);
      setShowDeleteSection(false);
      triggerFetch();
    }
  }

  return (
    <div className="delete_item">
      <div className="delete_content">
        <h1>Are you sure?</h1>
        <p>Please confirm you want to {buttonText} this.</p>
        <div className="btn_container">

          <button
            onClick={() => handleArchive(targetID)}
            className='delete'
          >{buttonText}
          </button>

          <button className='cancel'
            onClick={() => {
              setShowModal(false);
            }}
          >Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default ArchiveItem 